import { type LastScrapeDate as LastScrapeDateRaw, type StoreName } from '@bluebrick/discounts-service-module'
import type { Portal } from '@/types'

export type DiscountsLastScrapeDates<T> = Partial<Record<StoreName, T | undefined>>

export enum ScraperConfigurationStatus {
	ERROR = 'ERROR'
}

export type PortalStatus = {
	status: ScraperConfigurationStatus
}

export type PortalsStatus = Partial<Record<Portal, PortalStatus>>

export type LastScrapeDate = Omit<LastScrapeDateRaw, 'date'> & {
	date: Date
}
